import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { getCategoryMeta } from "@/lib/videoData";

interface VideoCardProps {
  video: Video;
  showTagline?: boolean;
}

export default function VideoCard({ video, showTagline = true }: VideoCardProps) {
  const category = getCategoryMeta(video.category);
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block cursor-pointer"
      aria-label={`查看 ${video.title} 详情`}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-primary-900">
        <img
          src={video.cover}
          alt={`${video.title} 封面`}
          title={`${video.title} - ${category?.name ?? ""} - 糖豆视频`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/10 to-transparent opacity-70 transition-opacity duration-300 group-hover:opacity-95" />

        <span className="absolute left-2 top-2 rounded bg-primary-950/70 px-1.5 py-0.5 text-[10px] font-medium text-background-100 backdrop-blur">
          {category?.name}
        </span>

        <span className="absolute right-2 top-2 flex items-center gap-1 rounded bg-accent-500 px-1.5 py-0.5 text-[11px] font-bold text-foreground-950">
          <i className="ri-star-fill text-[10px]" />
          {video.rating.toFixed(1)}
        </span>

        <div className="absolute inset-x-0 bottom-0 p-2.5">
          <p className="flex items-center gap-1 text-[11px] font-medium text-accent-300">
            <i className="ri-play-circle-fill text-xs" />
            {video.status}
          </p>
          {showTagline && (
            <p className="mt-1 line-clamp-2 text-[11px] leading-relaxed text-background-200/90 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              {video.tagline}
            </p>
          )}
        </div>
      </div>

      <h3 className="mt-2.5 line-clamp-1 text-[15px] font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
        {video.title}
      </h3>
      <p className="mt-1 line-clamp-1 text-xs text-foreground-600">
        {video.year} · {video.genre.join(" / ")}
      </p>
      <p className="mt-0.5 line-clamp-1 text-xs text-foreground-500">
        {video.actors.slice(0, 2).join("、")}
      </p>
    </Link>
  );
}